import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-recommend-inner -is-form" }
const _hoisted_2 = { class: "p-recommend-form__field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "現在の状況")
], -1)
const _hoisted_4 = { class: "p-recommend-form__error-wrap" }
const _hoisted_5 = { class: "p-recommend-form__set-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("現在の状況"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_7 = { class: "p-recommend-form__set-2-group" }
const _hoisted_8 = { class: "p-login-form__radio" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-current-status-employed"
}, "在職中", -1)
const _hoisted_11 = { class: "p-recommend-form__set-2-group" }
const _hoisted_12 = { class: "p-login-form__radio" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-current-status-unemployed"
}, "離職中", -1)
const _hoisted_15 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "経験業種")
], -1)
const _hoisted_17 = { class: "p-recommend-form__group-1" }
const _hoisted_18 = { class: "p-recommend-form__group-1-field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("経験業種"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_20 = { class: "p-recommend-form__error-wrap" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-2" }, "※主な経験業種を最近のものから順番に入力してください", -1)
const _hoisted_22 = {
  class: "p-recommend-form__list-1 --numbered js-entry-list",
  "data-entries": "6"
}
const _hoisted_23 = ["value", "onClick"]
const _hoisted_24 = ["onClick", "disabled"]
const _hoisted_25 = { class: "p-recommend-form__list-1-field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "経験年数", -1)
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "追加する", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "経験職種")
], -1)
const _hoisted_32 = { class: "p-recommend-form__group-1" }
const _hoisted_33 = { class: "p-recommend-form__group-1-field" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("経験職種"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_35 = { class: "p-recommend-form__error-wrap" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-2" }, "※主な経験職種を最近のものから順番に入力してください", -1)
const _hoisted_37 = { class: "p-recommend-form__list-1 --numbered" }
const _hoisted_38 = ["value", "onClick"]
const _hoisted_39 = ["onClick", "disabled"]
const _hoisted_40 = { class: "p-recommend-form__list-1-field" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "経験年数", -1)
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "追加する", -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "p-recommend-form__field" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "経験社数")
], -1)
const _hoisted_47 = { class: "p-recommend-form__error-wrap" }
const _hoisted_48 = { class: "p-recommend-form__group-1-field-set-1" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "社", -1)
const _hoisted_50 = { class: "p-recommend-form__field" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "マネジメント")
], -1)
const _hoisted_52 = { class: "p-recommend-form__error-wrap" }
const _hoisted_53 = { class: "p-recommend-form__set-2 js-radio-area" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "マネジメント経験", -1)
const _hoisted_55 = { class: "p-recommend-form__set-2-group" }
const _hoisted_56 = { class: "p-login-form__radio" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-management-yes"
}, "あり", -1)
const _hoisted_59 = { class: "p-recommend-form__set-2-group" }
const _hoisted_60 = { class: "p-login-form__radio" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-management-no"
}, "なし", -1)
const _hoisted_63 = {
  key: 0,
  class: "p-recommend-form__group-1 js-input-area"
}
const _hoisted_64 = { class: "p-recommend-form__group-1-field" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "マネジメント人数", -1)
const _hoisted_66 = { class: "p-recommend-form__group-1-field" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "マネジメント年数", -1)
const _hoisted_68 = { class: "p-recommend-form__field" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "職務要約"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1)
const _hoisted_70 = { class: "p-recommend-form__error-wrap" }
const _hoisted_71 = { class: "p-recommend-form__field" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "活かせる経験・知識・技術"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1)
const _hoisted_73 = { class: "p-recommend-form__error-wrap" }
const _hoisted_74 = { class: "p-recommend-form__field" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "自己PR"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1)
const _hoisted_76 = { class: "p-recommend-form__error-wrap" }
const _hoisted_77 = { class: "p-recommend-form__send-field --2-buttons" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", null, "前に戻る", -1)
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", null, "次へ進む", -1)
const _hoisted_81 = [
  _hoisted_80
]

import InvalidMessage from '@/components/InvalidMessage.vue';
import OccupationRadio from '@/components/OccupationRadio.vue';
import ValidatableField from '@/components/ValidatableField.vue';
import { CareerResumeInfoDetail } from '@/types';
import { inject, nextTick, ref, watch } from 'vue';
import ResumeSelect from '../components/ResumeSelect.vue';
import IndustryRadio from '@/components/IndustryRadio.vue';
import { useFieldError, ValidationResult } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkSummaryForm',
  props: {
    activeTab: null,
    isModalActive: { type: Boolean },
    careerData: null,
    setFieldValue: null,
    validateField: null
  },
  setup(__props: any) {

const props = __props as {
  activeTab: string;
  isModalActive: boolean
  careerData?: CareerResumeInfoDetail;
  setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
  validateField: (field: string) => Promise<ValidationResult>;
}

const MAX_OCCUP = 6;
const MAX_INDUSTRY = 6;
const MANAGEMENT_FLG_YES = 1;
const MANAGEMENT_FLG_NO = 2;

const managementFlgSelectedVal = ref(0);

watch(managementFlgSelectedVal, (newVal) => {
  if (newVal) {
    props.setFieldValue('managementPeopleId', '');
    props.setFieldValue('managementYearId', '');
  }
});



const switchTabAndValidateFn = inject<(tabId: string) => void>('switchTabAndValidate');

const expIndsCtg1IdErr = useFieldError('expIndsCtg1Id');
const industryList = ref<{
  id: number;
  isActive: boolean;
  isShow: boolean;
  selectedInd: {
    indsctgId: number | null;
    indsctgText: string;
  }
  selectedYearId: string;
}[]>([]);

function addIndustry() {
  const hidden = industryList.value.filter(i => !i.isShow)[0];
  if (hidden) {
    hidden.isShow = true;
  }
}

async function removeIndustry(idx: number) {
  industryList.value[idx].isShow = false;
  for (let i = idx; i < MAX_INDUSTRY - 1; i++) {
    if (industryList.value[i + 1]) {
      industryList.value[i] = { ...industryList.value[i + 1], id: industryList.value[i].id };
      props.setFieldValue(`expIndsCtg${i + 1}Id`, toEmpty(industryList.value[i + 1].selectedInd.indsctgId));
      props.setFieldValue(`expIndSctg${i + 1}YearsId`, toEmpty(industryList.value[i + 1].selectedYearId));
    }
  }
  industryList.value[MAX_INDUSTRY - 1] = {
    id: MAX_INDUSTRY,
    isShow: false,
    isActive: false,
    selectedInd: {
      indsctgId: 0,
      indsctgText: '',
    },
    selectedYearId: '',
  };
  props.setFieldValue(`expIndsCtg${MAX_INDUSTRY}Id`, '');
  props.setFieldValue(`expIndSctg${MAX_INDUSTRY}YearsId`, '');
  await props.validateField('expIndsCtg1Id');
}

const expOcupcTg1IdErr = useFieldError('expOcupcTg1Id');
const occupList = ref<{
  id: number;
  isActive: boolean;
  isShow: boolean;
  selectedOccup: {
    ocupctg3Id: string;
    ocupctg3Text: string;
  }
  selectedYearId: string;
}[]>([]);

function addOccup() {
  const hidden = occupList.value.filter(i => !i.isShow)[0];
  if (hidden) {
    hidden.isShow = true;
  }
}
async function removeOccup(idx: number) {
  occupList.value[idx].isShow = false;
  for (let i = idx; i < MAX_OCCUP - 1; i++) {
    if (occupList.value[i + 1]) {
      occupList.value[i] = { ...occupList.value[i + 1], id: occupList.value[i].id };
      props.setFieldValue(`expOcupcTg${i + 1}Id`, toEmpty(occupList.value[i + 1].selectedOccup.ocupctg3Id));
      props.setFieldValue(`expOcupCtg${i + 1}YearsId`, toEmpty(occupList.value[i + 1].selectedYearId));
    }
  }
  occupList.value[MAX_OCCUP - 1] = {
    id: MAX_OCCUP,
    isShow: false,
    isActive: false,
    selectedOccup: {
      ocupctg3Id: '',
      ocupctg3Text: '',
    },
    selectedYearId: '',
  };
  props.setFieldValue(`expOcupcTg${MAX_OCCUP}Id`, '');
  props.setFieldValue(`expOcupCtg${MAX_OCCUP}YearsId`, '');
  await props.validateField('expOcupcTg1Id');
}

watch(() => props.careerData, (newVal) => {
  if (newVal) {
    setFormData(newVal);
    initOccupList(newVal);
    initIndustryList(newVal);
  }
});
async function setValueOfIndsctgId(industry:any)
{
  props.setFieldValue(industry.name, toEmpty(industry.indsctgId));
  await props.validateField('expIndsCtg1Id');
}

async function setValueOfOcupId(ocup: any)
{
  props.setFieldValue(ocup.name, toEmpty(ocup.ocupctg3Id));
  await props.validateField('expOcupcTg1Id');
}
const toEmpty = (v: any) => v ? v : '';
async function setFormData(formData: CareerResumeInfoDetail) {
  managementFlgSelectedVal.value = formData.managementFlg;
  let wrkStatusId = formData.workStatusId;
  if (wrkStatusId != 1 && wrkStatusId != 2) {
    wrkStatusId = 0;
  }
  const careerObject: Record<string, any> = {
    'workStatusId': toEmpty(wrkStatusId),
    'expCompNum': formData.expCompNum,
    'jobSummary': formData.jobSummary,
    'expKnowledgeAbility': formData.expKnowledgeAbility,
    'selfPr': formData.selfPr,
    'managementFlg': formData.managementFlg,
    'managementPeopleId': toEmpty(formData.managementPeopleId),
    'managementYearId': toEmpty(formData.managementYearId),

    'expIndsCtg1Id': formData.expIndsCtg1Id,
    'expIndSctg1YearsId': toEmpty(formData.expIndSctg1YearsId),
    'expIndsCtg2Id': formData.expIndsCtg2Id,
    'expIndSctg2YearsId': toEmpty(formData.expIndSctg2YearsId),
    'expIndsCtg3Id': formData.expIndsCtg3Id,
    'expIndSctg3YearsId': toEmpty(formData.expIndSctg3YearsId),
    'expIndsCtg4Id': formData.expIndsCtg4Id,
    'expIndSctg4YearsId': toEmpty(formData.expIndSctg4YearsId),
    'expIndsCtg5Id': formData.expIndsCtg5Id,
    'expIndSctg5YearsId': toEmpty(formData.expIndSctg5YearsId),
    'expIndsCtg6Id': formData.expIndsCtg6Id,
    'expIndSctg6YearsId': toEmpty(formData.expIndSctg6YearsId),

    'expOcupcTg1Id': formData.expOcupcTg1Id,
    'expOcupCtg1YearsId': toEmpty(formData.expOcupCtg1YearsId),
    'expOcupcTg2Id': formData.expOcupcTg2Id,
    'expOcupCtg2YearsId': toEmpty(formData.expOcupCtg2YearsId),
    'expOcupcTg3Id': formData.expOcupcTg3Id,
    'expOcupCtg3YearsId': toEmpty(formData.expOcupCtg3YearsId),
    'expOcupcTg4Id': formData.expOcupcTg4Id,
    'expOcupCtg4YearsId': toEmpty(formData.expOcupCtg4YearsId),
    'expOcupcTg5Id': formData.expOcupcTg5Id,
    'expOcupCtg5YearsId': toEmpty(formData.expOcupCtg5YearsId),
    'expOcupcTg6Id': formData.expOcupcTg6Id,
    'expOcupCtg6YearsId': toEmpty(formData.expOcupCtg6YearsId),
  };
  await nextTick();
  for (const key in careerObject) {
    props.setFieldValue(key, careerObject[key]);
  }
}

function initIndustryList(formData: Record<string, any>) {
  let isShow = false;
  for(let i = MAX_INDUSTRY - 1; i >= 0 ; i--) {
    const expIndsId = formData[`expIndsCtg${i + 1}Id`];
    const expYearId = formData[`expIndSctg${i + 1}YearsId`];
    if (expIndsId || expYearId || !i) {
      isShow = true;
    }
    industryList.value.unshift({
      id: i + 1,
      isShow: isShow,
      isActive: false,
      selectedYearId: toEmpty(expYearId),
      selectedInd: {
        indsctgId: expIndsId || null,
        indsctgText: '',
      }
    });
  }
}
function initOccupList(formData: Record<string, any>) {
  let isShow = false;
  for(let i = MAX_OCCUP - 1; i >= 0 ; i--) {
    const expOcupId = formData[`expOcupcTg${i + 1}Id`];
    const expYearId = formData[`expOcupCtg${i + 1}YearsId`];
    if (expOcupId || expYearId || !i) {
      isShow = true;
    }
    occupList.value.unshift({
      id: i + 1,
      isShow: isShow,
      isActive: false,
      selectedYearId: toEmpty(expYearId),
      selectedOccup: {
        ocupctg3Id: expOcupId,
        ocupctg3Text: '',
      },
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "worksummary",
    class: _normalizeClass(["tab-content", { 'show': __props.activeTab === 'worksummary' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(InvalidMessage, { name: "workStatusId" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(ValidatableField, {
                id: "form-current-status-employed",
                type: "radio",
                name: "workStatusId",
                value: 1,
                rules: "required",
                label: "在職中"
              }),
              _hoisted_9
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(ValidatableField, {
                id: "form-current-status-unemployed",
                type: "radio",
                name: "workStatusId",
                value: 2,
                label: "離職中"
              }),
              _hoisted_13
            ]),
            _hoisted_14
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(InvalidMessage, { name: "expIndsCtg1Id" })
            ]),
            _hoisted_21,
            _createElementVNode("ul", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryList.value, (ind, i) => {
                return _withDirectives((_openBlock(), _createElementBlock("li", {
                  key: ind.id
                }, [
                  _createElementVNode("input", {
                    class: _normalizeClass(["p-recommend-form__modal-input-1", {'--is-error': (i == 0 && !!_unref(expIndsCtg1IdErr))}]),
                    id: "form-industry-type",
                    type: "text",
                    value: ind.selectedInd.indsctgText,
                    onClick: ($event: any) => (ind.isActive = true),
                    placeholder: "業種を選択",
                    readonly: ""
                  }, null, 10, _hoisted_23),
                  _createElementVNode("button", {
                    class: "p-recommend-form__delete-1",
                    type: "button",
                    onClick: ($event: any) => (removeIndustry(i)),
                    disabled: industryList.value.filter(_ => _.isShow).length == 1
                  }, "削除", 8, _hoisted_24),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(ResumeSelect, {
                      "class-name": "p-recommend-form__select",
                      id: "yearCategory",
                      label: `経験年数${i + 1}`,
                      name: `expIndSctg${i + 1}YearsId`,
                      "model-value": industryList.value[i].selectedYearId,
                      "onUpdate:model-value": ($event: any) => ((industryList.value[i].selectedYearId) = $event)
                    }, null, 8, ["label", "name", "model-value", "onUpdate:model-value"])
                  ]),
                  _createVNode(ValidatableField, {
                    value: industryList.value[i].selectedInd.indsctgId,
                    label: `経験業種${i + 1}`,
                    name: `expIndsCtg${i + 1}Id`,
                    rules: i == 0 ? 'required': '',
                    type: "hidden"
                  }, null, 8, ["value", "label", "name", "rules"]),
                  _createVNode(IndustryRadio, {
                    name: `industry-${i}-wrksmr`,
                    "is-active": industryList.value[i].isActive,
                    "onUpdate:is-active": ($event: any) => ((industryList.value[i].isActive) = $event),
                    "selected-industry": industryList.value[i].selectedInd,
                    "onUpdate:selected-industry": ($event: any) => ((industryList.value[i].selectedInd) = $event),
                    nameElement: `expIndsCtg${i + 1}Id`,
                    "onUpdate:setValue": setValueOfIndsctgId
                  }, null, 8, ["name", "is-active", "onUpdate:is-active", "selected-industry", "onUpdate:selected-industry", "nameElement"])
                ])), [
                  [_vShow, ind.isShow]
                ])
              }), 128))
            ]),
            _createElementVNode("button", {
              class: "p-recommend-form__add --mt-1",
              type: "button",
              onClick: addIndustry,
              disabled: industryList.value.filter(_ => _.isShow).length >= MAX_INDUSTRY
            }, _hoisted_29, 8, _hoisted_27)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createVNode(InvalidMessage, { name: "expOcupcTg1Id" })
            ]),
            _hoisted_36,
            _createElementVNode("ul", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(occupList.value, (occ, i) => {
                return _withDirectives((_openBlock(), _createElementBlock("li", {
                  key: occ.id
                }, [
                  _createElementVNode("input", {
                    class: _normalizeClass(["p-recommend-form__modal-input-1", {'--is-error': (i == 0 && !!_unref(expOcupcTg1IdErr))}]),
                    id: "form-job-type",
                    name: "form-job-type",
                    value: occ.selectedOccup.ocupctg3Text,
                    onClick: ($event: any) => (occ.isActive = true),
                    placeholder: "職種を選択",
                    readonly: ""
                  }, null, 10, _hoisted_38),
                  _createElementVNode("button", {
                    class: "p-recommend-form__delete-1",
                    type: "button",
                    onClick: ($event: any) => (removeOccup(i)),
                    disabled: occupList.value.filter(_ => _.isShow).length == 1
                  }, "削除", 8, _hoisted_39),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(ResumeSelect, {
                      "class-name": "p-recommend-form__select",
                      id: "yearCategory",
                      label: `経験年数${i + 1}`,
                      name: `expOcupCtg${i + 1}YearsId`,
                      "model-value": occupList.value[i].selectedYearId,
                      "onUpdate:model-value": ($event: any) => ((occupList.value[i].selectedYearId) = $event)
                    }, null, 8, ["label", "name", "model-value", "onUpdate:model-value"])
                  ]),
                  _createVNode(ValidatableField, {
                    value: occupList.value[i].selectedOccup.ocupctg3Id,
                    label: `経験職種${i + 1}`,
                    name: `expOcupcTg${i + 1}Id`,
                    rules: i == 0 ? 'required': '',
                    type: "hidden"
                  }, null, 8, ["value", "label", "name", "rules"]),
                  _createVNode(OccupationRadio, {
                    "is-active": occupList.value[i].isActive,
                    "onUpdate:is-active": ($event: any) => ((occupList.value[i].isActive) = $event),
                    "selected-occupation": occupList.value[i].selectedOccup,
                    "onUpdate:selected-occupation": ($event: any) => ((occupList.value[i].selectedOccup) = $event),
                    name: `occup-${i}`,
                    nameElement: `expOcupcTg${i + 1}Id`,
                    "onUpdate:setValue": setValueOfOcupId
                  }, null, 8, ["is-active", "onUpdate:is-active", "selected-occupation", "onUpdate:selected-occupation", "name", "nameElement"])
                ])), [
                  [_vShow, occ.isShow]
                ])
              }), 128))
            ]),
            _createElementVNode("button", {
              class: "p-recommend-form__add --mt-1",
              type: "button",
              onClick: addOccup,
              disabled: occupList.value.filter(_ => _.isShow).length >= MAX_OCCUP
            }, _hoisted_44, 8, _hoisted_42)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _hoisted_46,
        _createElementVNode("div", _hoisted_47, [
          _createVNode(InvalidMessage, { name: "expCompNum" })
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(ValidatableField, {
            class: "p-recommend-form__modal-input-2",
            id: "form-company-number",
            type: "text",
            name: "expCompNum",
            placeholder: "0",
            label: "経験社数",
            rules: "numeric|max:2",
            maxlength: "2"
          }),
          _hoisted_49
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _hoisted_51,
        _createElementVNode("div", _hoisted_52, [
          _createVNode(InvalidMessage, { name: "managementPeopleId" }),
          _createVNode(InvalidMessage, { name: "managementYearId" })
        ]),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("span", _hoisted_56, [
              _createVNode(ValidatableField, {
                id: "form-management-yes",
                type: "radio",
                name: "managementFlg",
                "model-value": managementFlgSelectedVal.value,
                "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => ((managementFlgSelectedVal).value = $event)),
                value: MANAGEMENT_FLG_YES,
                label: "あり"
              }, null, 8, ["model-value"]),
              _hoisted_57
            ]),
            _hoisted_58
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("span", _hoisted_60, [
              _createVNode(ValidatableField, {
                id: "form-management-no",
                type: "radio",
                name: "managementFlg",
                "model-value": managementFlgSelectedVal.value,
                "onUpdate:model-value": _cache[1] || (_cache[1] = ($event: any) => ((managementFlgSelectedVal).value = $event)),
                value: MANAGEMENT_FLG_NO,
                label: "なし"
              }, null, 8, ["model-value"]),
              _hoisted_61
            ]),
            _hoisted_62
          ]),
          (managementFlgSelectedVal.value == MANAGEMENT_FLG_YES)
            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode(ResumeSelect, {
                    rules: managementFlgSelectedVal.value == MANAGEMENT_FLG_YES ? 'required' : '',
                    "class-name": "p-recommend-form__select",
                    id: "peopleManagement",
                    label: "マネジメント人数",
                    name: "managementPeopleId"
                  }, null, 8, ["rules"])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createVNode(ResumeSelect, {
                    "class-name": "p-recommend-form__select",
                    rules: managementFlgSelectedVal.value == MANAGEMENT_FLG_YES ? 'required' : '',
                    id: "managementYearCategory",
                    name: "managementYearId",
                    label: "マネジメント年数"
                  }, null, 8, ["rules"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_68, [
        _hoisted_69,
        _createElementVNode("div", _hoisted_70, [
          _createVNode(InvalidMessage, { name: "jobSummary" })
        ]),
        _createVNode(ValidatableField, {
          as: "textarea",
          class: "p-recommend-form__textarea --extra-height-1",
          id: "form-message-1",
          type: "textarea",
          name: "jobSummary",
          placeholder: "例）大学卒業後、株式会社○○○へ入社し、営業部に配属。主に自動車業界向け計測器の営業を担当してきました。顧客に合わせた特注品の製造や生産調整など、海外メーカーとの折衝も経験いたしております。また、20xx年xx月からはグループリーダーとして約10名のメンバーの指導・育成にも携わり、グループ全体の目標達成に貢献してきました。",
          label: "職務要約",
          rules: "max:1000",
          maxlength: "1000"
        })
      ]),
      _createElementVNode("div", _hoisted_71, [
        _hoisted_72,
        _createElementVNode("div", _hoisted_73, [
          _createVNode(InvalidMessage, { name: "expKnowledgeAbility" })
        ]),
        _createVNode(ValidatableField, {
          as: "textarea",
          class: "p-recommend-form__textarea --extra-height-1",
          id: "form-message-2",
          type: "textarea",
          name: "expKnowledgeAbility",
          placeholder: "例）問題解決力と提案力：ソリューション提案型の営業を実践することで培われた問題解決力と提案力は、幅広い顧客から頼りにされるものであったと自負しております。高度な専門性と学ぶ意欲：大学で学んだ電気・機械・物理など理工系の知識と入社以来、勉強を続けてきた計測に関する専門知識、そして、自ら積極的に学ぶ姿勢は、他業界でも応用できるものと考えております。",
          label: "活かせる経験・知識・技術",
          rules: "max:1000",
          maxlength: "1000"
        })
      ]),
      _createElementVNode("div", _hoisted_74, [
        _hoisted_75,
        _createElementVNode("div", _hoisted_76, [
          _createVNode(InvalidMessage, { name: "selfPr" })
        ]),
        _createVNode(ValidatableField, {
          as: "textarea",
          class: "p-recommend-form__textarea --extra-height-1",
          id: "form-message-3",
          type: "textarea",
          name: "selfPr",
          placeholder: "例）顧客の潜在ニーズをくみ取れる営業を目指し、コミュニケーションを大切に業務に取り組んでいます。前職ではチームで報告・連絡・相談の連携を大切にするよう心掛けて、業務を円滑に進めて成約につなげることができました。貴社でも、前職で培ったコミュニケーション能力を活かして、顧客に満足していただける提案を行い成約につなげたいと考えております。",
          label: "自己PR",
          rules: "max:1000",
          maxlength: "1000"
        })
      ]),
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("a", {
          class: _normalizeClass(["p-recommend-form__send -is-prev", { 'active': __props.activeTab === 'basic-info' }]),
          href: "#basic-info",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(switchTabAndValidateFn)!('#basic-info')), ["prevent"]))
        }, _hoisted_79, 2),
        _createElementVNode("a", {
          class: _normalizeClass(["p-recommend-form__send -is-next", { 'active': __props.activeTab === 'workexperience' }]),
          href: "#workexperience",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(switchTabAndValidateFn)!('#workexperience')), ["prevent"]))
        }, _hoisted_81, 2)
      ])
    ])
  ], 2))
}
}

})